import { Updater, useQueryClient } from "@tanstack/react-query";

export const baseQueryKeys = [
  "products",
  "materials",
  "packagings",
  "orders",
  "utilities",
  "usage",
  "eol",
  "inbound_transport",
  "outbound_transport",
  "facilities",
  "datasets",
  "epd",
  "custom_impact_reference",
  "employees",
  "goods_and_services",
];

export const baseQueryKeysToReset = [...baseQueryKeys, "dashboard"];

export default function useSmartQueryClient() {
  const queryClient = useQueryClient();

  function invalidateBaseQueries(exceptFor?: string) {
    baseQueryKeysToReset
      .filter((x) => x !== exceptFor)
      .forEach((queryKey) => {
        queryClient.invalidateQueries([queryKey]);
      });
  }

  function setQueryData<R>(queryKey: any[], updater: Updater<R | undefined, R | undefined>) {
    const mainKey = queryKey[0];

    if (baseQueryKeys.includes(mainKey)) {
      invalidateBaseQueries(mainKey);
    }

    return queryClient.setQueryData<R>(queryKey, updater);
  }

  function invalidateQueries(queryKey?: any[]) {
    queryClient.invalidateQueries(queryKey);

    if (queryKey) {
      const mainKey = queryKey[0];

      if (baseQueryKeys.includes(mainKey)) {
        invalidateBaseQueries(mainKey);
      }
    }
  }

  return { invalidateQueries, setQueryData, invalidateBaseQueries };
}
